// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { IStrings } from '../../../IStrings';

export const strings: IStrings = {
  emptyList: 'No hay grupos administrados por GMM',
  loading: 'Cargando',
  refresh: 'Actualizar',
  continue: 'Continuar',
  addOwner204Message: 'Agregado correctamente.',
  addOwner400Message: 'GMM ya está agregado como propietario.',
  addOwner403Message: 'No tiene permiso para completar esta operación.',
  addOwnerErrorMessage:
    'Estamos teniendo problemas para agregar GMM como propietario. Inténtalo de nuevo más tarde.',
  okButton: 'Aceptar',
  groupIdHeader: 'Introduzca el ID de grupo',
  groupIdPlaceHolder: 'ID de grupo',
  addOwnerButton: 'Agregar GMM como propietario',
  membershipManagement: 'Membership Management',
  learnMembershipManagement: 'Aprenda cómo funciona Membership Management en su organización',
  maintenanceTitle: 'Esta aplicación está en mantenimiento',
  maintenanceMessage: 'La IU de GMM está en mantenimiento. Por favor intente de nuevo más tarde. Gracias por su paciencia.',
  permissionDenied: 'No tiene permiso para ver esta pagina. Por favor contacte a su administrador.',
  HROnboarding: {
    orgLeader: "Líder de la organización",
    provideOrgLeader: "Proporcionar líder de la organización",
    orgLeaderPlaceHolder: "Por favor ingrese Org. líder",
    orgLeaderInfo: "Proporcionar organización. líder",
    depth: "Profundidad",
    depthPlaceHolder: "Por favor ingrese la profundidad",
    depthInfo: "Define el nivel de profundidad máximo en la jerarquía organizativa utilizada para recuperar datos. El valor predeterminado es 'Todos', lo que significa que se incluirán a todos los que estén debajo de este org líder. Si se especifica profundidad '1 nivel abajo', se recuperará el líder de la organización y todos los que le reportan directamente al líder de la organización.",
    incrementButtonAriaLabel: "Aumentar el valor en 1",
    decrementButtonAriaLabel: "Disminuir valor en 1",
    filter: "Filtrar",
    filterPlaceHolder: "Por favor ingrese Filtro",
    filterInfo: "Proporcionar filtro",
    includeOrg: "¿Quiere que esta fuente se base en la estructura de la organización?",
    includeFilter: "¿Quieres filtrar por atributos de {0}?",
    includeLeader: "incluir líder",
    group: "Grupo",
    ungroup: "Desagrupar",
    attributeTitle: "Atributos",
    addAttribute: "Agregar atributo",
    attribute: "Seleccione el atributo",
    equalityOperator: "Seleccione el operador de igualdad",
    attributeValue: "Seleccione el operador de igualdad",
    orAndOperator: "Seleccione And/Or",
    attributeInfo: "Seleccione el atributo",
    equalityOperatorInfo: "Seleccione el operador de igualdad",
    equalityOperatorInfoTitle: 'Cómo usar los operadores:',
    inOperatorDescription: '{0} Operador — "¿Es uno de estos?" El operador {0} verifica si un valor coincide con alguno de los valores en una lista.{1}→ Ejemplo: Obtener usuarios que viven en Seattle, Portland o San Francisco. → Ciudad {0} (Seattle, Portland, San Francisco) devolverá todos los usuarios que viven en cualquiera de estas ciudades.',
    notInOperatorDescription: '{0} Operador — "¿No es uno de estos?" El operador {0} verifica si un valor no coincide con ninguno de los valores en una lista.{1}→ Ejemplo: Obtener usuarios que no viven en Seattle, Portland o San Francisco. → Ciudad {0} (Seattle, Portland, San Francisco) devolverá todos los usuarios que no viven en ninguna de estas ciudades.',
    notEqualToOperatorDescription: '{0} Operador — "¿Es diferente?"{1} El operador {0} significa "distinto de". Verifica si un valor es diferente de otro.{1} → Ejemplo: Obtener usuarios que no viven en Seattle. → Ciudad {0} Seattle devolverá todos los usuarios que no viven en Seattle.',
    attributeValueInfo: "Seleccione el operador de igualdad",
    orAndOperatorInfo: "Seleccione Y/O",
    missingAttributeErrorMessage: "Proporcione la información que falta en el atributo anterior",
    customOrgLeaderMissingErrorMessage: " no existe en ",
    orgLeaderMissingErrorMessage: "Este usuario no existe en la fuente de datos de RR.HH.",
    source: " fuente",
    invalidInputErrorMessage: "Entrada inválida. Por favor ingrese solo números.",
    valueComboBoxOptionCodeLabel: "Codigo: ",
    descriptionLabel: "Descripción: ",
    attributeDisabledErrorMessage: 'Este atributo ha sido deshabilitado. Si lo elimina y luego desea volver a agregarlo, deberá ponerse en contacto con {email} para obtener ayuda.',
    supportPlaceHolder: 'Administrador',
    all: 'Todos',
    level: "nivel",
    levelsPlural: "es",
    down: "abajo",
    up: "arriba",
    andOrInfoTitle: "Cómo utilizar AND / OR:",
    andLogicDescription: "{0} incluye a las personas que satisfacen {1} las condiciones.{2}→ Ejemplo: Department es A {3} Location es X – solo las personas que están en el Department A y ubicadas en X serán incluídas.",
    orLogicDescription: "{0} incluye a las personas que satisfacen {1} de las condiciones.{2}→ Ejemplo: Department es A {3} Location es X – las personas que están en el Department A o ubicadas en X serán incluídas.",
    AND: "AND",
    OR: "OR",
    any: "alguna",
    allLowercase: "todas",
    IN: "IN",
    NOTIN: "NOT IN",
    notEqualTo: "<>",
    loadingText: "Cargando...",
  },
  Components: {
    AppHeader: {
      title: 'Membership Management',
      settings: 'Configuración'
    },
    Banner:{
      bannerMessageStart:
      '¿Necesitas ayuda? Haz click aquí para aprender más sobre como Membership Management funciona en tu organización.',
      clickHere: 'Haz click aquí',
      bannerMessageEnd: ' para aprender más sobre como Membership Management funciona en tu organización.',
      expandBanner: 'Expandir banner'
    },
    HyperlinkSetting: {
      address: "URL",
      addHyperlink: "Agregar URL",
      invalidUrl: "URL inválida"
    },
    GroupQuerySource: {
      searchGroupSuggestedText: "Grupos sugeridos",
      noResultsFoundText: "No se encontraron resultados",
      loadingText: "Cargando",
      selectionAriaLabel: "Contactos seleccionados",
      removeButtonAriaLabel: "Eliminar",
      validQuery: "Consulta válida.",
      invalidQuery: "Error al analizar la consulta. Asegúrese de que sea JSON válido.",
      searchGroupName: "Buscar grupo"
    }
  },
  AdminConfig: {
    labels: {
      pageTitle: "Centro de Administrador",
      saveButton: "Guardar",
      saveSuccess:  "Guardado exitosamente."
    },
    Errors:{
      forbidden: 'Prohibido'
    },
    HyperlinkSettings: {
      labels: {
        hyperlinks: "Ligas",
        description: "Incluye ligas con información específica sobre cómo funciona XMM en tu organización para que los usuarios puedan aprovecharlo al máximo.",
      },
      dashboardLink: {
        title: "Dashboard",
        description: "Esta es la liga que se muestra en la esquina superior derecha del dashboard. Te lleva a un sitio interno que tiene todos los detalles sobre cómo aprovechar XMM en tu organización. Esto podría incluir preguntas frecuentes, información de contacto, SLAs, etc.",
      },
      outlookWarningLink: {
        title: "Instrucciones de destino",
        description: "Esta es la liga que aparece cuando Outlook está involucrado en el grupo seleccionado. Te lleva a un sitio interno para hacer la configuración adecuada al enviar correos electrónicos al grupo de Outlook.",
      },
      privacyPolicyLink: {
        title: "Política de Privacidad",
        description: "Esta es la liga que se muestra en la esquina inferior izquierda del dashboard. Te lleva a un sitio interno que tiene todos los detalles sobre cómo XMM maneja y almacena los datos de los usuarios.",
      },
    },
    Operations: {
      labels: {
        operations: "Operaciones",
        title: "Panel de Control GMM",
        description: "Utilice el botón Detener para detener las operaciones de GMM y el botón Restablecer para restablecer GMM en cualquier momento."
      },
      buttons: {
        stop: "Detener GMM",
        stopping: "Deteniendo",
        reset: "Restablecer GMM",
        resetting: "Restableciendo",
        start: "Iniciar GMM",
        starting: "Iniciando",
      }
    },
    CustomSourceSettings: {
      labels: {
        customSource: "Origen Personalizado",
        sourceDescription: "Asigne un nombre descriptivo al origen de los datos de su organización para que los propietarios de grupos lo reconozcan al definir el origen de sus destinos de pertenencia.",
        sourceCustomLabelInput: "Nombre personalizado",
        listOfAttributes: "Lista de Atributos",
        listOfAttributesDescription: "Asigne un nombre descriptivo a cada uno de los atributos de el origen personalizado para que los propietarios de grupos los reconozcan al definir la fuente de sus destinos de pertenencia.",
        attributeColumn: "Atributo",
        customLabelColumn: "Nombre Personalizado",
        customLabelInputPlaceHolder: "Entre un nombre personalizado",
        valuesColumn: "Valores",
        valuesDropdownSpinnerLabel: "Cargando valores",
        valuesDropdownPlaceholder: "Ver valores",
        valuesDropdownTitle: "Seleccione un valor",
        descriptionColumn: "Descripción",
        descriptionPlaceHolder: "Ingrese una etiqueta personalizada",
        enabledColumn: "Habilitado",
        enabledToggleTitle: "Habilitar o deshabilitar este atributo",
      },
    },
    GeneralSettings: {
      labels: {
        general: "General",
        reviewOwnSubmissionTitle: "Permisos de los Verificadores de Solicitud",
        reviewOwnSubmissionDescription: "¿Pueden los Verificadores de Solicitud aceptar o rechazar su propia solicitud?",
        createGroupTitle: "Crear grupo habilitado",
        createGroupDescription: "¿Debería GMM permitir que los propietarios de grupos creen nuevos grupos?",
        businessJustificationTitle: "Justificación de Negocio",
        businessJustificationDescription: "¿Debería GMM requerir una justificación de negocio para la administración de la membresía o realizar algun cambio?",
        isDisclaimerEnabledTitle: "¿Está habilitado el aviso de visita inicial?",
        isDisclaimerEnabledDescription: "Habilitar el aviso para que se muestre a los usuarios cuando visiten GMM por primera vez.",
      }
    }
  },
  Authentication: {
    loginFailed: 'Ocurrió un error inesperado durante el inicio de sesión.'
  },
  JobDetails: {
    labels: {
      pageTitle: 'Detalle de Membresía',
      sectionTitle: 'Detalle de Membresía',
      lastModifiedby: 'Última vez modificado por',
      requestedBy: 'Solicitado por',
      requestedOnBehalfOf: 'Solicitado en nombre de',
      groupLinks: 'Links del grupo',
      destination: 'Destino',
      type: 'Tipo',
      name: 'Nombre',
      ID: 'ID',
      teamName: 'Nombre del equipo',
      channelName: 'Nombre del canal',
      channelId: 'ID del canal',
      configuration: 'Configuración',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de terminación',
      lastRun: 'Última sincronización',
      nextRun: 'Próxima sincronización',
      frequency: 'Frecuencia',
      frequencyDescription: 'Cada {0} hrs',
      requestor: 'Solicitante',
      increaseThreshold: 'Límite de incremento',
      decreaseThreshold: 'Límite de decremento',
      noThresholdSet: 'No se estableció un límite',
      thresholdViolations: 'Violaciones del límite',
      sourceParts: 'Partes de origen',
      membershipStatus: 'Estado de la membresía',
      sync: 'Sync',
      enabled: 'Activo',
      disabled: 'Inactivo',
      pendingReview: 'Revisión pendiente',
      pendingReviewDescription: 'La configuración de la membresía está esperando ser verificada.',
      pendingReviewInstructions: 'Por favor revisa esta solicitud y luego aprueba o rechaza después de revisar la configuración de la membresía.',
      businessJustification: 'Justificación de la membresía',
      approve: 'Aprobar',
      reject: 'Rechazar',
      submissionRejected: 'Solicitud rechazada',
      rejectionDialogTitle: 'Rechazar solicitud',
      rejectionDialogSubText: 'Por favor proporciona una razón para rechazar esta solicitud.',
      rejectionReasonLabel: 'Razón del rechazo',
      rejectionReasonPlaceholder: 'Ingresa la razón para rechazar esta solicitud...',
      submitRejection: 'Enviar',
      submittingRejection: 'Enviando...',
      removeGMM: 'Dejar de administrar con GMM',
      removeGMMWarning: '¿Estás seguro de que deseas dejar de administrar este grupo con GMM? Deberás eliminar manualmente a GMM de los dueños del grupo.',
      removeGMMConfirmation: 'Confirmar (Liga se abrirá en una nueva pestaña.)',
    },
    descriptions: {
      requestedBy: 'Usuario que realizó el cambio a este trabajo.',
      requestedOnBehalfOf: 'Usuario en cuyo nombre se realizó el cambio en este trabajo.',
      startDate: 'Fecha en la que este grupo fue integrado a GMM.',
      endDate: 'Fecha de la última sincronización de este grupo.',
      type: 'El tipo de destino. Actualmente, GMM solo administra la membresía de los destinos de grupo. En el futuro, también admitirá la membresía de los canales de Teams.',
      id: 'ID de objecto del grupo destino.',
      lastRun: 'Fecha de la última sincronización de este grupo.',
      nextRun: 'Fecha de la próxima sincronización de este grupo.',
      frequency: 'Frecuencia de la sincronización de este grupo.',
      requestor: 'Usuario quien solicitó la integración a GMM.',
      increaseThreshold:
        'Si GMM detecta grandes cambios en la membresía, usted (el propietario del grupo) puede querer revisar estos cambios. Esta configuración permite a GMM suspender las actualizaciones si se supera un umbral que usted define. Este valor (expresado como un porcentaje del tamaño actual del grupo) limita el número de usuarios que pueden ser añadidos al grupo objetivo. Si se supera el número, GMM esperará su aprobación para continuar.',
      decreaseThreshold:
        'Si GMM detecta grandes cambios en la membresía, usted (el propietario del grupo) puede querer revisar estos cambios. Esta configuración permite a GMM suspender las actualizaciones si se supera un umbral que usted define. Este valor (expresado como un porcentaje del tamaño actual del grupo) limita el número de usuarios que pueden ser eliminados del grupo objetivo. Si se supera el número, GMM esperará su aprobación para continuar.',
      thresholdViolations:
        'Número de ocasiones en las que se han excedido los límites.',
    },
    MessageBar: {
      dismissButtonAriaLabel: 'Cerrar',
    },
    Errors:{
      jobInProgress: 'La sincronización está en progreso. Por favor intente más tarde.',
      forbidden: 'Esta operación no está permitida.',
      internalError: 'No podemos procesar su solicitud en este momento. Por favor, inténtelo de nuevo más tarde.',
      removeGMMError: 'Error al dejar de administrar con GMM.',
      submitterNotOwner: 'Esta solicitud fue rechazada ya que el solicitante ya no era propietario cuando se revisó la solicitud.',
      reviewerCannotReviewOwnSubmission: 'Esto no puede ser completado ya que no está permitido revisar revisar tu propia solicitud.',
      rejectionError: 'Error al rechazar la solicitud. Por favor, inténtelo de nuevo.',
    },
    Panel: {
      dismissButtonAriaLabel: 'Cerrar panel de historial',
      changeTimeColumnLabel: 'Fecha',
      changedByColumnLabel: 'Modificado por',
      changeReasonColumnLabel: 'Tipo de cambio',
      changeDetailsColumnLabel: 'Detalles',
      viewDetails: 'Ver detalles',
      history: 'Historial de Cambios',
      configurationPivotHeader: 'Configuración',
      onboardingRequest: 'Solicitud inicial',
      statusUpdate: 'Actualización de estado',
      update: 'Solicitud de Actualización de sincronización',
      submissionApproved: 'Solicitud aprobada',
      submissionRejected: 'Solicitud rechazada',
      businessJustification: 'Justificación del cambio',
      groupSettings: 'Configuración del grupo',
    },
    notFound: 'La sincronización de membresía para el grupo con ID {0} ahora está deshabilitada porque el grupo ya no existe.',
    openInAzure: 'Abrir en Azure',
    openInTeams: 'Abrir en Teams',
    viewDetails: 'Ver Detalles',
    editButton: 'Editar',
  },
  JobsList: {
    listOfMemberships: 'Grupos administrados',
    ShimmeredDetailsList: {
      toggleSelection: 'Alternar selección',
      toggleAllSelection: 'Alternar selecciones para todo',
      selectRow: 'seleccionar fila',
      ariaLabelForShimmer: 'Recuperando contenido',
      ariaLabelForGrid: 'Detalles de contenido',
      columnNames: {
        name: 'Nombre',
        type: 'Tipo',
        email: 'Correo electrónico',
        lastRun: 'Última sincronización',
        nextRun: 'Próxima sincronización',
        status: 'Status',
        actionRequired: 'Acción requerida',
      },
    },
    MessageBar: {
      dismissButtonAriaLabel: 'Cerrar',
    },
    PagingBar: {
      previousPage: 'Ant',
      nextPage: 'Sig',
      page: 'Página',
      of: 'de',
      display: 'Mostrando',
      items: 'Elementos por página',
      pageNumberAriaLabel: 'Número de página',
      pageSizeAriaLabel: 'Tamaño de página'
    },
    JobsListFilter: {
      filters: {
        ID: {
          label: 'ID',
          placeholder: 'Buscar',
          validationErrorMessage: 'GUID inválido!',
        },
        status: {
          label: 'Estado',
          options: {
            all: 'Todos',
            enabled: 'Activo',
            disabled: 'Inactivo',
          },
        },
        actionRequired: {
          label: 'Acción requerida',
          options: {
            all: 'Todos',
            thresholdExceeded: 'Límite excedido',
            customerPaused: 'En pausa',
            developerPaused: 'Pausado por el desarrollador',
            membershipDataNotFound: 'Datos de membresía no encontrados',
            destinationGroupNotFound: 'Grupo de destino no encontrado',
            notOwnerOfDestinationGroup: 'No es propietario del grupo de destino',
            securityGroupNotFound: 'Grupo de seguridad no encontrado',
            pendingReview: 'Revisión pendiente',
            submissionRejected: 'Solicitud rechazada',
          },
        },
        destinationType: {
          label: 'Tipo de destinación',
          options: {
            all: 'Todos',
            channel: 'Canal',
            group: 'Grupo'
          }
        },
        destinationName: {
          label: 'Destinación',
          placeholder: 'Buscar por nombre, correo electrónico o ID de objeto',
        },
        ownerPeoplePicker: {
          label: 'Dueño',
          suggestionsHeaderText: 'Personas sugeridas',
          noResultsFoundText: 'No se encontraron resultados',
          loadingText: 'Cargando',
          selectionAriaLabel: 'Contactos seleccionados',
          removeButtonAriaLabel: 'Eliminar'
        },
      },
      filterButtonText: 'Filtrar',
      clearButtonTooltip: 'Eliminar filtros',
    },
    NoResults: 'No se encontro ninguna membresía',
  },
  ManageMembership: {
    manageMembershipButton: 'Administrar membresía',
    addSyncButton: 'Agregar sincronización',
    bulkAddSyncsButton: 'Agregar sincronizaciones',
    bulkApproveSyncsButton: 'Bulk Approve Syncs',
    downloadButton: 'Descargar',
    downloadingButton: 'Descargando',
    uploadHeader: 'Subir archivo CSV',
    uploadingLabel: 'Subiendo…',
    chooseFileButton: 'Elegir archivo',
    selectCSVFileLabel: 'Seleccionar archivo CSV',
    csvErrorMessage: 'Ocurrió un error desconocido al analizar el archivo CSV. Por favor, inténtelo de nuevo más tarde.',
    uploadErrorMessage: 'Por favor, suba un archivo CSV válido.',
    uploadCompleteLabel: 'Carga completa:',
    totalNumberOfJobsLabel: 'Total # de trabajos:',
    totalNumberOfApprovedJobsLabel: '# de trabajos aprobados:',
    approveErrorStatusLabel: 'Error',
    approveButton: 'Aprobar',
    labels: {
      abandonOnboarding: '¿Abandonar Onboarding?',
      abandonOnboardingDescription: '¿Estás seguro de que quieres abandonar el onboarding en progreso y regresar?',
      alreadyOnboardedWarning: 'Este grupo ya está siendo sincronizado por GMM.',
      confirmAbandon: 'Sí, regresar',
      pageTitle: 'Manejo de Membresía',
      step1title: 'Paso 1: Selecciona el destino',
      step1description: 'Por favor selecciona el tipo de destino y el destino cuya membresía quieres administrar.',
      selectOrCreateGroup: 'Seleccionar o crear un grupo',
      selectDestinationType: 'Seleccionar tipo de destino',
      searchGroupSuggestedText: 'Grupos sugeridos',
      searchChannelSuggestedText: 'Canales sugeridos',
      searchGroup: 'Buscar grupo',
      searchTeam: 'Buscar equipo de Teams',
      searchChannel: 'Buscar canal',
      selectDestination: 'Seleccionar destino existente',
      createNewGroup: 'Crear un nuevo grupo',
      selectDestinationTypePlaceholder: 'Buscar un grupo',
      noResultsFound: 'No se encontraron resultados',
      appsUsed: 'Este grupo utiliza las siguientes aplicaciones.',
      entraSecurityGroup: 'Este es un grupo de seguridad de Entra',
      outlookWarning: 'Hay configuraciones importantes que deben considerarse antes de enviar un correo electrónico a este grupo de Outlook. Por favor, siga las instrucciones proporcionadas por su organización.',
      teamsNotSupportedWarning: "Atención: Este grupo de Teams no es compatible con GMM. Por favor, seleccione un grupo diferente.",
      appIdNotOwnerWarning: 'Para administrar la membresía de este grupo, GMM debe ser propietario del grupo.{2} {0}{2}Una vez que hayas hecho eso, regresa y haz clic en: {1}',
      addOwnerMessage: 'Agregar {0} como propietario.',
      teamsServiceAccountNotOwnerWarning: 'GMM no es propietario de este canal de Teams. No podrá administrar la membresía de este canal hasta que lo agregues.{2} {0}{2}Una vez que hayas hecho eso, regresa y haz clic en: {2}{1}',
      userNotOwnerWarning: 'Atención: No eres dueño de este grupo. Solo los propietarios pueden administrar la membresía.',
      groupDescription: 'Los grupos pueden ser de Outlook / M365, Grupos de seguridad de Entra, Teams, comunidades de Viva Engage o sitios de SharePoint, etc.',
      channelDescription: 'El canal puede ser un canal privado o compartido de Teams.',
      step2title: 'Paso 2: Configuración de ejecución ',
      step2description: '',
      advancedQuery: 'Consulta avanzada',
      advancedView: 'Vista avanzada',
      query: 'Consulta',
      validQuery: 'Consulta válida.',
      invalidQuery: 'Error al analizar la consulta. Asegúrese de que sea JSON válido.',
      invalidGroups: 'Grupos inválido:',
      invalidSqlFilters: "Filtro de SQL inválido. Asegure que cada filtro contiene SQL válido.",
      step3title: 'Paso 3: Configuración de Membresía',
      step3description: 'Defina el orígen de la membresía para el destino. Puede agregar múltiples partes de origen para definir el orígen de la membresía, cada una con su propio criterio. GMM combinará todas las partes de origen para determinar la membresía del grupo destino.',
      selectStartDate: 'Selecciona una opción para comenzar a administrar la membresía',
      ASAP: 'Lo antes posible- Después de ser aprobada la solicitud, GMM comenzará a administrar la membresía lo antes posible.',
      requestedDate: 'Solicitar fecha- Una vez que la solicitud sea aprobada, GMM comenzará a administrar la membresía en la fecha solicitada o lo antes posible si la fecha solicitada ya pasó.',
      selectRequestedStartDate: 'Selecciona una fecha de inicio solicitada',
      from: 'Desde',
      frequency: 'La solución de gestión de membresías está configurada para sincronizarse cada 24 horas. Por favor, contacta con tu administrador para solicitar una frecuencia diferente.',
      hrs: 'hrs',
      preventAutomaticSync: '¿Prevenir sincronización automática si los cambios en la membresía exceden los límites de incremento y/o decremento?',
      preventAutomaticSyncInfo: 'Seleccionar \'Sí\' significa protección y visibilidad adicionales. Si se detecta un cambio drástico en la membresía, los propietarios del grupo recibirán una notificación de alerta detallada para aprobar o pausar los intentos de sincronización. Por ejemplo, con un umbral de aumento del 20% y un umbral de disminución del 15% en 100 miembros, la sincronización se detendrá por encima de 120 miembros o por debajo de 85 miembros.',
      preventAutomaticSyncWarning: 'Advertencia: Seleccionar \'No\' significa que las sincronizaciones de membresía se producirán sin notificación, independientemente de cuán drástico sea el aumento o la disminución de la membresía en los proyectos de GMM.  Esto puede ser perjudificial en situaciones en las que se produce un cambio mal configurado en la definición de pertenencia (por ejemplo, por parte del propietario de un grupo) o un cambio erróneo en la información de origen (por ejemplo, por alguien de RR.HH.).',
      increase: 'Incremento',
      decrease: 'Decremento',
      step4title: 'Paso 4: Confirmación',
      step4description: '',
      objectId: 'ID del objeto',
      sourceParts: 'Partes de origen',
      sourcePart: 'Parte de origen',
      noThresholdSet: 'No se estableció un límite',
      savingSyncJob: 'Guardando...',
      updatingSyncJob: 'Actualizando...',
      group: 'Grupo',
      destinationPickerSuggestionsHeaderText: 'Destinos sugeridos',
      expand: 'Expandir',
      collapse: 'Contraer',
      sourceType: 'Tipo de origen',
      addSourcePart: 'Agregar parte de origen',
      excludeSourcePart: 'Excluir parte de origen',
      deleteLastSourcePartWarning: 'No se puede eliminar la última parte de origen.',
      errorOnSchema: 'Esperaba {0} pero recibió tipo {1} en {2}.',
      searchGroupName: 'Buscar grupo',
      HR: 'RH',
      groupMembership: 'Membresía de grupo',
      groupOwnership: 'Propietario de grupo',
      placeMembership: 'Membresía de lugar',
      clickHere: 'Haz click aquí',
      requestor: 'Solicitante',
      requestorInfo: 'El solicitante es la persona que inicialmente solicitó que GMM gestione la membresía de este destino. Esta persona debe ser propietaria del destino. Esto nos ayuda a rastrear a quién contactar si tenemos preguntas sobre la sincronización inicial. De lo contrario, el solicitante no tiene más derechos sobre el destino que cualquier otro propietario.',
      businessJustificationSubtitle: '¿Cuál es el propósito de la administración de la membresía de este destino?',	
      businessJustificationPrompt: 'Proporcione una justificación comercial para la administración de la membresía de este destino.',
      businessJustificationPlaceholder: 'Escriba su respuesta aquí...',
      requestedBy: 'Solicitado por',
      requestedOnBehalfOf: 'Solicitado en nombre de',
      requestedOnBehalfOfPlaceholder: 'Seleccionar propietario del destino',
      requestedOnBehalfOfDescription: 'Este es el propietario del destino a nombre de quien se está realizando la solicitud de administración de la membresía.',
      expandAll: 'Expandir todo',
      collapseAll: 'Contraer todo',
    },
    CreateGroup: {
      createNewGroup: 'Crear un nuevo grupo',
      groupName: 'Nombre del nuevo grupo',
      groupNamePlaceholder: 'Nombre del nuevo grupo',
      groupAlias: 'Alias del nuevo grupo',
      groupAliasPlaceholder: 'Alias del nuevo grupo',
      creating: 'Creando...',
      created: 'Creado',
      createGroup: 'Crear grupo',
      authorizedSenders: 'Remitentes autorizados',
      authorizedSendersToolTip: 'Especifica las personas o grupos que tienen permiso para enviar mensajes. Si se especifica un grupo, todos los miembros de ese grupo tendrán permisos de envío. Déjalo en blanco para permitir que cualquiera envíe mensajes. Este campo es obligatorio para grupos con más de 5,000 miembros.',
      hiddenFromExchangeClients: 'Ocultar de los clientes de Exchange',
      hiddenFromExchangeClientsToolTip: 'Cuando está oculto, este grupo no aparecerá en la sección de Grupos del cliente de Outlook. También elimina el acceso de los miembros al buzón del grupo, incluidos el historial de mensajes y las invitaciones del calendario.',
      welcomeMessageEnabled: 'Mensaje de bienvenida habilitado',
      welcomeMessageEnabledToolTip: 'Controla si se envía un mensaje de bienvenida por correo electrónico cuando se agregan nuevos miembros al grupo.'
    }
  },
  Disclaimer: {
    title: 'Por favor lea y acepte lo siguiente antes de continuar:',
    submitButton: 'Estoy de acuerdo',
    membershipRules: 'Revisaré las reglas de membresía antes de enviarlas y reconozco que los miembros se poblarán según los criterios especificados.',
    membershipRulesBoldNote: 'Acepto la responsabilidad por cualquier error causado por criterios incorrectos.',
    outlookWelcomeMessage: 'Entiendo que, de forma predeterminada, la creación de un grupo de Outlook genera un mensaje de bienvenida automático para los nuevos miembros. Para evitar notificaciones excesivas, WelcomeMessageEnabled debe configurarse en False antes de agregar miembros.',
    autoSubscribeSettings: 'Entiendo que {0}} y {1} deben estar configurados en True para que los miembros reciban correos electrónicos e invitaciones de calendario. {2}',
    autoSubscribeSettingsBoldNote: 'Solo los usuarios que sean agregados después de que se hayan configurado estas opciones serán automáticamente suscritos al grupo.',
    autoSubscribeNewMembersLabel: 'AutoSubscribeNewMembers',
    autoSubscribeNewMembersDescription: 'Configurar en True significa que los nuevos miembros recibirán correos electrónicos e invitaciones de calendario.',
    autoSubscribeNewMembersDescriptionLinkText: 'Aprende más',
    autoSubscribeNewMembersDescriptionLinkUrl: 'https://learn.microsoft.com/en-us/powershell/module/exchange/set-unifiedgroup?view=exchange-ps#-autosubscribenewmembers',
    subscribeMembersToCalendarEventsLabel: 'AutoSubscribeExistingMembers',
    subscribeMembersToCalendarEventsDescription: 'Configurar en True significa que los nuevos miembros recibirán invitaciones de calendario.',
    subscribeMembersToCalendarEventsDescriptionLinkText: 'Aprende más',
    subscribeMembersToCalendarEventsDescriptionLinkUrl: 'https://learn.microsoft.com/en-us/powershell/module/exchange/set-unifiedgroup?view=exchange-ps#-alwayssubscribememberstocalendarevents',
    authorizedSenders: 'Entiendo que para los grupos de {0}. Para grupos con menos de 5,000 miembros, esto queda a discreción del propietario del grupo.',
    authorizedSendersBoldNote: 'Outlook con más de 5,000 miembros, se deben establecer remitentes autorizados para evitar fallas en la entrega de correos electrónicos',
    teamsVivaNotifications: 'Entiendo que para Teams y Viva Engage, los miembros serán notificados de acuerdo con el flujo de notificaciones de su plataforma, que no se puede omitir.',
    flatList: 'Reconozco que los Grupos de M365 no admiten anidamiento y todos los miembros se incluyen en una lista plana.',
  },
  copy: 'Copiar',
  remove: 'Eliminar',
  delete: 'Eliminar',
  edit: 'Editar',
  submit: 'Enviar',
  needHelp: '¿Necesitas ayuda?',
  next: 'Siguiente',
  cancel: 'Cancelar',
  close: 'Cerrar',
  learnMore: 'Aprende más',
  errorItemNotFound: 'Elemento no encontrado',
  welcome: 'Bienvenido',
  back: 'Regresar',
  backToDashboard: 'Regresar al dashboard',
  version: 'Versión',
  yes: 'Sí',
  no: 'No',
  or: 'O',
  and: 'Y',
  true: 'Verdadero',
  false: 'Falso',
  privacyPolicy: 'Política de Privacidad',
  hoursAgo: '{0}, {1} horas atrás',
  hoursLeft: '{0}, {1} horas restantes',
  pendingInitialSync: 'En espera de correr el primer sync',
};
